import { connect } from 'react-redux';
import Policy from './Policy';


let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
    domain: state.aboutPage.aboutData.domain,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const PolicyContainer = connect(mapStateToProps, mapDispatchToProps)(Policy);

export default PolicyContainer;